<template>
  <div class="environment-page">
    <!-- 背景装饰：柔光渐变与网格 → 与 About 风格统一 -->
    <!--<div class="bg-decor env-decor-1" aria-hidden="true"></div>-->
    <!--<div class="bg-decor env-decor-2" aria-hidden="true"></div>-->
    <!--<div class="bg-grid" aria-hidden="true"></div>-->
    <!-- 顶部横幅 -->
    <div class="environment-banner">
      <div class="banner-content" data-aos="fade-down">
        <h1>校园环境</h1>
        <p>艺术与自然的完美融合</p>
        <div class="banner-badges">
          <span class="badge">生态园林</span>
          <span class="badge">现代设施</span>
          <span class="badge">创作空间</span>
        </div>
      </div>
    </div>

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="container">
        <router-link to="/">首页</router-link>
        <span> / </span>
        <span>校园环境</span>
      </div>
    </div>

    <div class="container">
      <!-- 校园全景 -->
      <section class="environment-section panorama" data-aos="fade-up">
        <div class="section-header">
          <h2>校园全景</h2>
          <div class="divider"></div>
          <p class="section-description">我们的校园融合现代建筑与自然景观，为艺术创作提供灵感源泉</p>
        </div>
        <div class="panorama-gallery">
          <Gallery :images="panoramaImages" />
        </div>
      </section>

      <!-- 功能区划 -->
      <section class="environment-section zones" data-aos="fade-up">
        <div class="section-header">
          <h2>校园功能区划</h2>
          <div class="divider"></div>
        </div>
        <div class="zones-container">
          <div class="zone-tabs">
            <button
                v-for="(zone, index) in campusZones"
                :key="index"
                :class="{ active: activeZone === index }"
                @click="activeZone = index"
            >
              {{ zone.name }}
            </button>
          </div>
          <div class="zone-content">
            <transition name="fade" mode="out-in">
              <div :key="activeZone" class="zone-detail">
                <div class="zone-text">
                  <h3>{{ campusZones[activeZone].name }}</h3>
                  <p>{{ campusZones[activeZone].description }}</p>
                  <ul class="zone-features" v-if="campusZones[activeZone].features">
                    <li v-for="(feature, fIndex) in campusZones[activeZone].features" :key="fIndex">
                      <i class="fas fa-check"></i> {{ feature }}
                    </li>
                  </ul>
                </div>
                <div class="zone-image">
                  <img :src="campusZones[activeZone].image" :alt="campusZones[activeZone].name">
                  <div class="zone-image-overlay"></div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </section>

      <!-- 四季校园（新增） -->
      <section class="environment-section seasons" data-aos="fade-up" v-show="false">
        <div class="section-header">
          <h2>四季校园</h2>
          <div class="divider"></div>
          <p class="section-description">春夏秋冬，校园的每一刻都充满艺术灵感</p>
        </div>
        <div class="seasons-gallery">
          <div class="season-tabs">
            <button
                v-for="(season, sIndex) in campusSeasons"
                :key="sIndex"
                :class="{ active: activeSeason === sIndex }"
                @click="activeSeason = sIndex"
            >
              {{ season.name }}
            </button>
          </div>
          <div class="season-content">
            <transition name="fade" mode="out-in">
              <div :key="activeSeason">
                <div class="season-lead">
                  <p>{{ campusSeasons[activeSeason].description }}</p>
                </div>
                <div class="season-grid">
                  <div class="season-card" v-for="(img, i) in campusSeasons[activeSeason].images" :key="i" data-aos="zoom-in" :data-aos-delay="i * 60">
                    <div class="season-image">
                      <img :src="img.src" :alt="img.alt">
                    </div>
                    <div class="season-caption">{{ img.caption }}</div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </section>

      <!-- 特色景观 -->
      <section class="environment-section classroom-photos" data-aos="fade-up">
        <div class="section-header">
          <h2>教室课堂风采</h2>
          <div class="divider"></div>
        </div>
        <div class="features-grid">
          <div
              v-for="(photo, index) in classroomPhotos"
              :key="index"
              class="feature-card shiny"
              @mouseenter="hoveredFeature = index"
              @mouseleave="hoveredFeature = null"
          >
            <div class="feature-image">
              <img :src="photo.image" :alt="'课堂照片 ' + (index + 1)">
              <div class="feature-overlay" :class="{ active: hoveredFeature === index }">
                <h3>{{ photo.caption }}</h3>
              </div>
            </div>
            <div class="feature-content">
              <h3>{{ photo.caption }}</h3>
              <p>{{ photo.description }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 虚拟导览 -->
      <section class="environment-section virtual-tour" v-if="false">
        <div class="section-header">
          <h2>虚拟校园导览</h2>
          <div class="divider"></div>
          <p class="section-description">点击下方区域开始探索我们的校园</p>
        </div>
        <div class="tour-container">
          <div class="tour-map">
            <img src="@/assets/images/campus-map.png" alt="校园地图" usemap="#campusmap">
            <map name="campusmap">
              <area
                  v-for="(area, index) in tourAreas"
                  :key="index"
                  shape="rect"
                  :coords="area.coords"
                  :alt="area.name"
                  @click="showTourModal(area)"
              >
            </map>
          </div>
          <div class="tour-start">
            <h3>开始虚拟导览</h3>
            <p>选择您感兴趣的校园区域，体验360°全景浏览</p>
            <button class="btn btn-tour" @click="startVirtualTour">
              <i class="fas fa-vr-cardboard"></i> 开始导览
            </button>
          </div>
        </div>
      </section>
    </div>

    <!-- 虚拟导览模态框 -->
    <div v-if="showTour" class="tour-modal" @click.self="closeTourModal">
      <div class="modal-content">
        <button class="close-btn" @click="closeTourModal">
          <i class="fas fa-times"></i>
        </button>
        <h3>{{ currentTourArea.name }}</h3>
        <div class="tour-viewer">
          <img :src="currentTourArea.panorama" alt="全景图">
          <div class="tour-controls">
            <button @click="rotateView('left')">
              <i class="fas fa-arrow-left"></i>
            </button>
            <button @click="rotateView('right')">
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
        <p class="tour-description">{{ currentTourArea.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Gallery from '@/components/Gallery.vue'

export default {
  name: 'EnvironmentPage',
  components: {
    Gallery
  },
  data() {
    return {
      activeZone: 0,
      activeSeason: 0,
      hoveredFeature: null,
      showTour: false,
      currentViewAngle: 0,
      currentTourArea: {},
      panoramaImages: [
        {
          src: require('@/assets/resources/学校环境介绍/6cd9b4b04d88f156af5194a2f2e87ad.jpg'),
          alt: '校园全景',
          caption: ''
        },
        {
          src: require('@/assets/resources/学校环境介绍/4db7263459b6da311d945c4641f65f0.jpg'),
          alt: '校园全景',
          caption: ''
        },
        {
          src: require('@/assets/resources/学校环境介绍/6688023d25bec244aa2b991f5ff3c826.jpg'),
          alt: '校园全景',
          caption: ''
        },
        {
          src: require('@/assets/resources/学校环境介绍/1ff38c3e43fcfeb8944a4499b6d7d6b9.jpg'),
          alt: '校园全景',
          caption: ''
        },
        {
          src: require('@/assets/resources/学校环境介绍/ceca481fcfb4c7aa59d1d477cfcbea1.jpg'),
          alt: '校园全景',
          caption: ''
        },
        {
          src: require('@/assets/resources/学校环境介绍/d478578bcaa7151a6b8fbdaa8da9a5a.jpg'),
          alt: '校园全景',
          caption: ''
        }
      ],
      campusZones: [
        {
          name: '教学区',
          description: '教学区配备专业画室、素描教室、色彩教室等现代化教学设施。每间教室都采用自然采光设计，为艺术创作提供最佳光线条件。',
          features: [
            '素描教室',
            '色彩教室',
            '多媒体教室',
            '艺术讲座厅'
          ],
          image: require('@/assets/resources/学校环境介绍/d478578bcaa7151a6b8fbdaa8da9a5a.jpg')
        },
        {
          name: '学校食堂',
          description: '学校食堂为学生提供丰富多样的餐饮选择，环境宽敞明亮，干净整洁。每日供应营养均衡的早餐、午餐和晚餐，同时设有自助餐区和特色小吃区，让学生在轻松舒适的环境中享受美味。',
          features: [
            '多样菜品',
            '自助餐区',
            '特色小吃',
            '干净卫生',
            '舒适就餐环境'
          ],
          image: require('@/assets/resources/学校环境介绍/1ff38c3e43fcfeb8944a4499b6d7d6b9.jpg')
        }
      ],
      specialFeatures: [
        {
          name: '艺术长廊',
          description: '连接各教学楼的长廊，两侧展示历届优秀学生作品和教师创作，成为移动的艺术课堂。',
          image: require('@/assets/resources/学校环境介绍/4a6e6818cb0d9fdc7ba9925db9e1aaee.jpg')
        },
        {
          name: '创意空间',
          description: '开放式创意空间，设有写生平台和展示区，是校园最受欢迎的创作和休闲场所。',
          image: require('@/assets/resources/学校环境介绍/6cd9b4b04d88f156af5194a2f2e87ad.jpg')
        },
        {
          name: '材料工坊',
          description: '集中存放各类艺术创作材料的仓库，学生可借用专业工具和获取基础材料支持。',
          image: require('@/assets/resources/学校环境介绍/70bf59b5e5ad7185bae2d1fdde6b09c.jpg')
        },
        {
          name: '展示中心',
          description: '专门用于展示学生优秀作品的空间，定期更换展示内容，展示学生的创作成果。',
          image: require('@/assets/resources/学校环境介绍/1ff38c3e43fcfeb8944a4499b6d7d6b9.jpg')
        }
      ],
      tourAreas: [
        {
          name: '主教学楼',
          coords: '200,150,350,300',
          panorama: require('@/assets/resources/学校环境介绍/4a6e6818cb0d9fdc7ba9925db9e1aaee.jpg'),
          description: '学校标志性建筑，包含油画、国画、版画等传统艺术专业教室，中央天井设计提供充足自然光线。'
        },
        {
          name: '设计中心',
          coords: '400,200,550,350',
          panorama: require('@/assets/resources/学校环境介绍/6cd9b4b04d88f156af5194a2f2e87ad.jpg'),
          description: '现代设计专业教学区，配备苹果电脑实验室、3D打印室和多媒体制作间，开放式布局促进跨专业交流。'
        },
        {
          name: '艺术图书馆',
          coords: '100,350,250,500',
          panorama: require('@/assets/resources/学校环境介绍/70bf59b5e5ad7185bae2d1fdde6b09c.jpg'),
          description: '收藏中外艺术书籍、画册和电子资源，设有个人研习间和小组讨论区，安静舒适的学习环境。'
        },
        {
          name: '雕塑花园',
          coords: '300,400,450,550',
          panorama: require('@/assets/resources/学校环境介绍/1ff38c3e43fcfeb8944a4499b6d7d6b9.jpg'),
          description: '户外雕塑作品展示区，同时作为雕塑专业教学场所，定期更换学生和特邀艺术家作品。'
        }
      ],
      campusSeasons: [
        {
          name: '春季',
          description: '校园内花卉盛开，是学生户外写生的黄金季节。',
          images: [
            {
              src: require('@/assets/resources/学校环境介绍/4a6e6818cb0d9fdc7ba9925db9e1aaee.jpg'),
              alt: '春季校园-教学楼',
              caption: '春季教学楼'
            },
            {
              src: require('@/assets/resources/学校环境介绍/6cd9b4b04d88f156af5194a2f2e87ad.jpg'),
              alt: '春季校园-创作区',
              caption: '春季创作区'
            },
            {
              src: require('@/assets/resources/学校环境介绍/70bf59b5e5ad7185bae2d1fdde6b09c.jpg'),
              alt: '春季校园-户外写生',
              caption: '春季户外写生'
            }
          ]
        },
        {
          name: '夏季',
          description: '夏季校园绿树成荫，学生们在室内外进行各种艺术创作。',
          images: [
            {
              src: require('@/assets/resources/学校环境介绍/1ff38c3e43fcfeb8944a4499b6d7d6b9.jpg'),
              alt: '夏季校园-展览区',
              caption: '夏季展览区'
            },
            {
              src: require('@/assets/resources/学校环境介绍/4a6e6818cb0d9fdc7ba9925db9e1aaee.jpg'),
              alt: '夏季校园-教学楼',
              caption: '夏季教学楼'
            },
            {
              src: require('@/assets/resources/学校环境介绍/6cd9b4b04d88f156af5194a2f2e87ad.jpg'),
              alt: '夏季校园-工作室',
              caption: '夏季工作室'
            }
          ]
        },
        {
          name: '秋季',
          description: '秋季校园色彩丰富，是学生进行色彩写生的理想季节。',
          images: [
            {
              src: require('@/assets/resources/学校环境介绍/70bf59b5e5ad7185bae2d1fdde6b09c.jpg'),
              alt: '秋季校园-展览区',
              caption: '秋季展览区'
            },
            {
              src: require('@/assets/resources/学校环境介绍/1ff38c3e43fcfeb8944a4499b6d7d6b9.jpg'),
              alt: '秋季校园-创作区',
              caption: '秋季创作区'
            },
            {
              src: require('@/assets/resources/学校环境介绍/4a6e6818cb0d9fdc7ba9925db9e1aaee.jpg'),
              alt: '秋季校园-教学楼',
              caption: '秋季教学楼'
            }
          ]
        },
        {
          name: '冬季',
          description: '冬季校园安静祥和，学生们在室内进行创作和学习。',
          images: [
            {
              src: require('@/assets/resources/学校环境介绍/6cd9b4b04d88f156af5194a2f2e87ad.jpg'),
              alt: '冬季校园-工作室',
              caption: '冬季工作室'
            },
            {
              src: require('@/assets/resources/学校环境介绍/70bf59b5e5ad7185bae2d1fdde6b09c.jpg'),
              alt: '冬季校园-展览区',
              caption: '冬季展览区'
            },
            {
              src: require('@/assets/resources/学校环境介绍/1ff38c3e43fcfeb8944a4499b6d7d6b9.jpg'),
              alt: '冬季校园-教学楼',
              caption: '冬季教学楼'
            }
          ]
        }
      ],
      classroomPhotos: [
        {
          caption: '课堂专注学习',
          description: '学生们在老师指导下专注绘画，氛围浓厚，学习热情高涨。',
          image: require('@/assets/resources/学校环境介绍/8681c252cfd23507dd1c674829456dd.jpg')
        },
        // {
        //   caption: '小组合作练习',
        //   description: '同学们分组讨论创作方案，课堂互动积极，充满创意火花。',
        //   image: require('@/assets/resources/学校环境介绍/classroom2.jpg')
        // },
        {
          caption: '老师讲解示范',
          description: '老师在讲台上示范绘画技巧，学生认真观察学习。',
          image: require('@/assets/resources/学校环境介绍/9ec85deb2eea4c6a337c0f5da6a9da6.jpg')
        },
        {
          caption: '课堂实操练习',
          description: '每位学生在课桌上完成自己的创作，体现实际操作能力。',
          image: require('@/assets/resources/学校环境介绍/31d7c000a9ee36f5f87997a52444ec8.jpg')
        }
      ],
    }
  },
  methods: {
    showTourModal(area) {
      this.currentTourArea = area
      this.currentViewAngle = 0
      this.showTour = true
    },
    closeTourModal() {
      this.showTour = false
    },
    rotateView(direction) {
      if (direction === 'left') {
        this.currentViewAngle -= 90
      } else {
        this.currentViewAngle += 90
      }
      // 在实际应用中，这里会切换不同的全景图片或使用CSS变换
    },
    startVirtualTour() {
      // 在实际应用中，这里会链接到专业的虚拟导览系统
      this.showTourModal(this.tourAreas[0])
    }
  }
}
</script>

<style scoped>
.environment-page {
  color: #333;
}

.bg-decor { position: absolute; border-radius: 50%; filter: blur(40px); opacity: 0.35; pointer-events: none; }
.env-decor-1 { width: 460px; height: 460px; top: -140px; left: -140px; background: radial-gradient(circle, rgba(66,185,131,0.5), rgba(66,185,131,0)); }
.env-decor-2 { width: 520px; height: 520px; bottom: -200px; right: -200px; background: radial-gradient(circle, rgba(44,62,80,0.5), rgba(44,62,80,0)); }
.bg-grid { position: absolute; inset: 0; background-image: linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px); background-size: 22px 22px; pointer-events: none; }

/* 顶部横幅样式 */
.environment-banner {
  height: 300px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
  url('@/assets/images/common-banner.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

.banner-badges { margin-top: 14px; display: inline-flex; gap: 10px; }
.badge { padding: 6px 10px; border-radius: 999px; font-size: 12px; letter-spacing: 0.06em; background: rgba(255,255,255,0.14); border: 1px solid rgba(255,255,255,0.22); }

.banner-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-content p {
  font-size: 1.5rem;
  opacity: 0.9;
}

/* 面包屑导航 */
.breadcrumb { padding: 12px 0; background: transparent; margin: 10px 0 24px; font-size: 0.95rem; }
.breadcrumb .container { display: flex; align-items: center; gap: 6px; color: #7f8c8d; }
.breadcrumb a { color: var(--default-red-color); text-decoration: none; }
.breadcrumb a:hover { text-decoration: underline; }
.breadcrumb span { color: #9aa6ac; }

/* 通用区块样式 */
.environment-section {
  margin-bottom: 60px;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-header h2 {
  font-size: 2.2rem;
  color: #2c3e50;
  margin-bottom: 15px;
}

.section-description {
  max-width: 800px;
  margin: 0 auto;
  color: #555;
  font-size: 1.1rem;
  line-height: 1.6;
}

.divider {
  width: 80px;
  height: 3px;
  background-color: var(--default-red-color);
  margin: 15px auto;
}

/* 功能区划样式 */
.zones-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.seasons { position: relative; }
.seasons::before { content: ''; position: absolute; left: 0; right: 0; top: -30px; height: 60px; background: radial-gradient(1000px 60px at 50% 0, rgba(66,185,131,0.1), transparent); pointer-events: none; }

.zone-tabs {
  display: flex;
  border-bottom: 1px solid #eee;
}

.zone-tabs button {
  flex: 1;
  padding: 15px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  color: #7f8c8d;
  transition: all 0.3s;
  position: relative;
}

.zone-tabs button:hover {
  color: var(--default-red-color);
}

.zone-tabs button.active {
  color: var(--default-red-color);
  font-weight: bold;
}

.zone-tabs button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 3px;
  background-color: var(--default-red-color);
}

.zone-content {
  padding: 30px;
}

.zone-detail {
  display: flex;
  gap: 40px;
}

.zone-text {
  flex: 1;
}

.zone-text h3 {
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 1.5rem;
}

.zone-text p {
  color: #555;
  line-height: 1.8;
  margin-bottom: 20px;
}

.zone-features {
  list-style: none;
  padding-left: 0;
}

.zone-features li {
  margin-bottom: 10px;
  color: #555;
}

.zone-features i {
  color: var(--default-red-color);
  margin-right: 8px;
}

.zone-image {
  flex: 1;
  position: relative;
}

.zone-image img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  display: block;
}

.zone-image-overlay { position: absolute; inset: 0; background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.25)); border-radius: 8px; pointer-events: none; }

/* 特色景观样式 */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.feature-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.feature-card.shiny::after { content: ''; position: absolute; top: -120%; left: -120%; width: 220%; height: 220%; background: linear-gradient(120deg, rgba(255,255,255,0) 42%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 58%); transform: rotate(10deg); transition: transform 0.6s ease, opacity 0.6s ease; opacity: 0; }
.feature-card.shiny:hover::after { transform: rotate(10deg) translate(18%,18%); opacity: 1; }

.feature-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.feature-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;
}

.feature-card:hover .feature-image img {
  transform: scale(1.05);
}

.feature-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.feature-overlay.active {
  opacity: 1;
}

.feature-overlay h3 {
  color: white;
  text-align: center;
  padding: 0 20px;
}

.feature-content {
  padding: 20px;
}

.feature-content h3 {
  color: #2c3e50;
  margin-bottom: 10px;
}

.feature-content p {
  color: #7f8c8d;
  line-height: 1.6;
}

/* 虚拟导览样式 */
.tour-container {
  display: flex;
  gap: 40px;
  align-items: center;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.tour-map {
  flex: 2;
  position: relative;
}

.tour-map img {
  width: 100%;
  border-radius: 8px;
}

.tour-start {
  flex: 1;
  text-align: center;
}

.tour-start h3 {
  color: #2c3e50;
  margin-bottom: 15px;
}

.tour-start p {
  color: #7f8c8d;
  margin-bottom: 25px;
  line-height: 1.6;
}

.btn-tour {
  background-color: #2c3e50;
  padding: 12px 25px;
  font-size: 1.1rem;
}

.btn-tour i {
  margin-right: 8px;
}

/* 四季校园样式 */
.seasons-gallery {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.season-tabs {
  display: flex;
  border-bottom: 1px solid #eee;
}

.season-tabs button {
  flex: 1;
  padding: 15px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  color: #7f8c8d;
  transition: all 0.3s;
  position: relative;
}

.season-tabs button:hover {
  color: var(--default-red-color);
}

.season-tabs button.active {
  color: var(--default-red-color);
  font-weight: bold;
}

.season-content {
  padding: 20px;
}

.season-lead { color: #556; margin-bottom: 12px; }
.season-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 18px; }
.season-card { background: #fff; border: 1px solid #eef2ef; border-radius: 10px; overflow: hidden; box-shadow: 0 6px 16px rgba(0,0,0,0.04); transition: transform 0.25s ease, box-shadow 0.25s ease; }
.season-card:hover { transform: translateY(-4px); box-shadow: 0 12px 28px rgba(0,0,0,0.08); }
.season-image { height: 170px; overflow: hidden; }
.season-image img { width: 100%; height: 100%; object-fit: cover; display: block; }
.season-caption { padding: 10px 12px; color: #2c3e50; font-weight: 500; text-align: center; }

/* 虚拟导览模态框样式 */
.tour-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  width: 90%;
  max-width: 800px;
  border-radius: 8px;
  padding: 30px;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #7f8c8d;
  cursor: pointer;
}

.modal-content h3 {
  color: #2c3e50;
  text-align: center;
  margin-bottom: 20px;
}

.tour-viewer {
  position: relative;
  height: 400px;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 8px;
}

.tour-viewer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tour-controls {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.tour-controls button {
  background-color: rgba(255, 255, 255, 0.7);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 1.2rem;
  color: #2c3e50;
  cursor: pointer;
  transition: all 0.3s;
}

.tour-controls button:hover {
  background-color: white;
  transform: scale(1.1);
}

.tour-description {
  color: #555;
  line-height: 1.6;
  text-align: center;
}

/* 过渡动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .zone-detail {
    flex-direction: column;
  }

  .tour-container {
    flex-direction: column;
  }

  .tour-map {
    margin-bottom: 30px;
  }
}

@media (max-width: 768px) {
  .environment-banner {
    height: 300px;
  }

  .banner-content h1 {
    font-size: 2.5rem;
  }

  .banner-content p {
    font-size: 1.2rem;
  }

  .section-header h2 {
    font-size: 1.8rem;
  }

  .zone-tabs {
    flex-wrap: wrap;
  }

  .zone-tabs button {
    flex: 1 0 50%;
    padding: 12px;
    font-size: 1rem;
  }

  .tour-viewer {
    height: 300px;
  }
}

@media (max-width: 576px) {
  .environment-banner {
    height: 300px;
  }

  .banner-content h1 {
    font-size: 2rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .season-tabs button {
    flex: 1 0 50%;
    padding: 10px;
    font-size: 1rem;
  }

  .modal-content {
    width: 95%;
    padding: 20px 15px;
  }

  .tour-viewer {
    height: 250px;
  }

  .tour-controls button {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
}
</style>
